import axios from 'axios'
import qs from 'qs'
Vue.axios = axios

import {
    NewsCategory,
    NewsList,
    StrategyList,
    NewsBanner,
    WholeArticleList,
    SearchAds
} from 'apiAddress'

// 汇市阅读
export default{
    /**
     * 获取侧边栏分类列表
     */
     getCategories:function(){
         return axios.post(NewsCategory);
     },
     /**
      * 获取汇市阅读列表
      * @param pageNo 页码
      * @param pageSize 每页条数
      * @param cid 栏目id
      */
      getNewsList:function(params){
          return axios.post(NewsList, qs.stringify(params));
      },
      /**
       * 获取推荐EA策略列表
       */
      getStrategies:function(){
          return axios.post(StrategyList);
      },
      /**
       * 获取汇市阅读banner
       */
      getNewsBanner: function(){
          return axios.post(NewsBanner)
      },
      /**
       * 获取全站搜索结果列表
       * @param keyword
       * @param pageNo
       */
      getWholeArticleList:function(params){
         return axios.post(WholeArticleList, qs.stringify(params));
      },
      /**
       * 获取侧边栏广告列表
       */
      getSearchAds:function(){
        return axios.post(SearchAds);
      }

}



// WEBPACK FOOTER //
// ./src/service/news/api/index.js